import PropTypes from 'prop-types';
import { useParams, useNavigate } from 'react-router-dom';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase, IconButton, useMediaQuery } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import DropDown from 'ui-component/atoms/DropDown';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';

// assets
import { IconMenu2, IconChevronDown } from '@tabler/icons';
import { fontSize } from '@mui/system';
import { useDispatch } from 'react-redux';
import { SET_SELECTED_TYPE } from 'store/actions';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle, dropDown, rightSidebarOpen, handleRightSidebarToggle }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { client } = params;
    const handleChange = (e) => {
        const selectedClient = e.target.value;
        if (selectedClient !== client) {
            navigate(`/${selectedClient}`);
            dispatch({ type: SET_SELECTED_TYPE, payload: selectedClient });
        }
    };
    const dropDownComponent =
        dropDown.list && isMobile ? <DropDown list={dropDown.list} label="Clients" selectedValue={client} onChange={handleChange} /> : null;
    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: { xs: 'auto', md: 228 },
                    width: { xs: 'auto', md: 228 }
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                <IconButton
                    onClick={handleLeftDrawerToggle}
                    sx={{
                        mr: 1,
                        p: 1.5,
                        display: { xs: 'flex', md: 'none' },
                        alignItems: 'center',
                        justifyContent: 'center',
                        minWidth: '44px',
                        minHeight: '44px',
                        width: '44px',
                        height: '44px',
                        zIndex: 1300,
                        position: 'relative',
                        backgroundColor: theme.palette.secondary?.light || '#e0e0e0',
                        color: theme.palette.secondary?.dark || '#424242',
                        borderRadius: '8px',
                        '&:hover': {
                            backgroundColor: theme.palette.secondary?.dark || '#616161',
                            color: theme.palette.secondary?.light || '#f5f5f5'
                        },
                        // Ensure visibility on mobile with multiple approaches
                        '@media (max-width: 900px)': {
                            display: 'flex !important',
                            visibility: 'visible !important',
                            opacity: '1 !important',
                            pointerEvents: 'auto !important'
                        }
                    }}
                    aria-label="menu"
                    className="mobile-menu-toggle"
                >
                    <IconMenu2 stroke={1.5} size="1.5rem" />
                </IconButton>
            </Box>
            <Box sx={{ flexGrow: 1 }} />
            {/* {dropDownComponent} */}
            {/* header search */}
            {/* <SearchSection /> */}
            {/* <Box sx={{ flexGrow: 1 }} /> */}
            <Box sx={{ flexGrow: 1 }} />

            {/* notification & profile */}
            {/* <NotificationSection /> */}
            <ProfileSection />

            {/* Right sidebar toggle button - mobile only */}
            {isMobile && handleRightSidebarToggle && (
                <IconButton
                    onClick={handleRightSidebarToggle}
                    sx={{
                        mr: 1,
                        p: 1.5,
                        minWidth: '44px',
                        minHeight: '44px',
                        width: '44px',
                        height: '44px',
                        backgroundColor: theme.palette.secondary?.light || '#e0e0e0',
                        color: theme.palette.secondary?.dark || '#424242',
                        borderRadius: '8px',
                        '&:hover': {
                            backgroundColor: theme.palette.secondary?.dark || '#616161',
                            color: theme.palette.secondary?.light || '#f5f5f5'
                        },
                        transform: rightSidebarOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.3s ease'
                    }}
                    aria-label="toggle right sidebar"
                >
                    <IconChevronDown stroke={1.5} size="1.5rem" />
                </IconButton>
            )}
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func,
    dropDown: PropTypes.shape({
        selectedValue: PropTypes.string,
        list: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
                displayName: PropTypes.string
            })
        )
    }),
    rightSidebarOpen: PropTypes.bool,
    handleRightSidebarToggle: PropTypes.func
};
Header.defaultProps = {
    dropDown: {}
};

export default Header;
